<template>
  <div class="common_group">
    <div class="title">
      <img src="@/assets/images/informationIcon.png">
      <span>{{ $t('newApp.activityInfo.ei') }}</span>
    </div>
    <div class="common_readonly_template">
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.noa') }}</div>
            <commonTooltip class="text" ref-name="activityDataActivityName" :content="activityData.activityName" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.businessUnit">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.bu') }}</div>
            <commonTooltip class="text" ref-name="activityDataBusinessUnit" :content="activityData.businessUnit" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.coa') }}</div>
            <div class="text">{{ activityData.activityClassification }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.relatedActivityName && activityData.relatedActivityCode && !($store.state.useSimplifiedForm && activityData.activityClassificationCode === 'AC_06')">
          <div>
            <div class="label">{{ activityData.relationActivityName }}</div>
            <commonTooltip class="text" ref-name="activityDataRelatedActivityName" :content="hdActiveValue" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.foa') }}</div>
            <div class="text">{{ activityData.activityForms }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="16" :xl="16" v-if="activityData.organizer">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.Organizer') }}</div>
            <div class="text">{{ activityData.organizer }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.tnoptbi') }}</div>
            <div class="text">{{ activityData.inviterNum }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.targetObject">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.mta') }}</div>
            <div class="text">{{ formatTargetObject(activityData.targetObject, activityData.targetObjectOther) }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.toa') }}</div>
            <div class="text">{{ activityData.activityType }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.qdMeetingSegment">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.cms') }}</div>
            <div class="text">{{ activityData.qdMeetingSegment }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="!$store.state.useSimplifiedForm">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ps') }}</div>
            <div class="text">{{ activityData.brandPromotionSupport }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.hc') }}</div>
            <div class="text">{{ activityData.city }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.edoh') }}</div>
            <div class="text">{{ activityData.expectStartDate }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.eed') }}</div>
            <div class="text">{{ activityData.expectEndDate }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.activityBaseName">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.hdjd') }}</div>
            <div class="text">{{ activityData.activityBaseName }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.activityBaseContactInformation">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.jdlx') }}</div>
            <div class="text">{{ activityData.activityBaseContactInformation }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.salerDeptCode && activityData.salerDeptCode.indexOf('000063') === 0">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.jma') }}</div>
            <div class="text">{{ activityData.isUnionMarket ? $t('general.yes') : $t('general.no') }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.isUnionMarket === 1">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ic') }}</div>
            <div class="text">{{ activityData.isInternationalQd ? $t('general.yes') : $t('general.no') }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.isUnionMarket === 1">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.cst') }}</div>
            <div class="text">{{ activityData.unionChannelType }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.isUnionMarket === 1">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.cn') }}</div>
            <div class="text">{{ activityData.unionChannelName }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="!$store.state.useSimplifiedForm">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.csl') }}</div>
            <div class="text">{{ activityData.activityLevelName }}</div>
          </div>
        </el-col>
        <!-- 高层/关键客户活动（简化UI用户） -->
        <el-col v-if="$store.state.useSimplifiedForm" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.skca') }}</div>
            <div class="text">{{ activityData.seniorKeyCustomerActivity === '1' ? $t('general.yes') : activityData.seniorKeyCustomerActivity === '0' ? $t('general.no') : '--' }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.activityClassificationCode === 'AC_06'">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.dynags') }}</div>
            <div class="text">{{ activityData.needOrganizer ? $t('general.yes') : $t('general.no') }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.budgetAmount">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ba') }}</div>
            <div class="text">{{ activityData.budgetAmount }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="activityData.organizerReason">
          <div>
            <div class="label">{{ $t('approvalCenter.ReasonsApplication') }}</div>
            <div class="text">{{ activityData.organizerReason }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.remotePoc && !$store.state.useSimplifiedForm">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.rp') }}</div>
            <div class="text">{{ activityData.remotePoc }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.unitedDiamondActivity && !$store.state.useSimplifiedForm">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.jra') }}</div>
            <div class="text">{{ activityData.unitedDiamondActivity }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.circleActivity && !$store.state.useSimplifiedForm">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ca') }}</div>
            <div class="text">{{ activityData.circleActivity }}</div>
          </div>
        </el-col>
        <!-- 样机演示/体验 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.machineDemo && !$store.state.useSimplifiedForm">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.machineDemo') }}</div>
            <div class="text">{{ activityData.machineDemo }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.templateVisit && !$store.state.useSimplifiedForm">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.mv') }}</div>
            <div class="text">{{ activityData.templateVisit }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="echoData.mactModuleList && echoData.mactModuleList.length > 0">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.teietcs') }}</div>
            <div class="text">{{ activityData.mactModuleList }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="echoData.mactProductLineList && echoData.mactProductLineList.length > 0">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.artpl') }}</div>
            <div class="text">{{ activityData.productlineSupplement }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="echoData.mactCommunicationScenarioList && echoData.mactCommunicationScenarioList.length > 0 && lang === 'zh-CN'">
          <div>
            <div class="label">{{ comscValue }}</div>
            <div class="text">{{ activityData.communicationScenarioList }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="echoData.mactAgendaList && echoData.mactAgendaList.length > 0">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.agenda') }}</div>
            <div class="text">{{ activityData.agendaList }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ActivityBgA') }}</div>
            <div class="text">{{ activityData.activityBackgroundPurpose || '--' }}</div>
          </div>
        </el-col>
        <!-- 活动目标（简化UI用户） -->
        <el-col v-if="$store.state.useSimplifiedForm" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.hdmb') }}</div>
            <div class="text">{{ activityData.activityTarget || '--' }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import commonTooltip from '@/components/commonTooltip';
import { isNotEmpty } from '../../../../../utils/utils';
import { newApplicationFormApi } from '@/views/newApplicationForm/service';
import { targetObjectDisplayMixin } from '@/views/newApplicationForm/mixins/targetObjectMixin';

export default {
  mixins: [targetObjectDisplayMixin],
  props: {
    echoData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      activityData: {},
      lang: localStorage.getItem('lang') || 'zh-CN',
      comscValue: ''
    };
  },
  components: {
    commonTooltip
  },
  computed: {
    hdActiveValue () {
      let value = '';
      switch (this.activityData.activityClassificationCode) {
      case 'AC_03':
      case 'AC_06':
        value = this.activityData.hqActivityName;
        break;
      case 'AC_01':
        value = this.activityData.relatedActivityName;
        break;
      }
      return value;
    }
  },
  mounted () {
    this.activityData = {
      ...this.echoData.marketActivityExpand,
      ...this.echoData.marketActivity
    };
    let params = [
      'plate', // 预计板块
      'qd_meeting_segment', // 渠道会议细分
      'activity_type', // 活动类型
      'organizer', // 主办方
      'target_object', // 目标对象
      'other_classification', // 其他分类
      'union_market_help',
      'activity_forms',
      'activity_classification',
      'productline_supplement',
      'activity_goal',
      'expense_detail_item',
      'smb_international_activity_type',
      'activity_level'
    ];
    // 获取活动相关下拉数据（如活动分类、活动层级等）
    newApplicationFormApi.getActivityList(params).then(res => {
      const data = res.data
      // 获取活动分类列表
      const activity_classification = data.activity_classification
      // 在活动分类中查找与当前活动分类编码匹配的项
      const found = activity_classification.find(item => item.fieldKey === this.activityData.activityClassificationCode)
      if (found) {
        // 将匹配到的fieldValue赋值给relationActivityName（活动分类名称）
        this.$set(this.activityData,'relationActivityName',found.fieldValue)
      }
      // 获取活动层级列表
      const activity_level = data.activity_level;
      // 在活动层级中查找与当前活动层级编码匹配的项
      const levelFound = activity_level.find(item => item.fieldKey === this.activityData.activityLevel);
      if (levelFound) {
        // 将匹配到的fieldValue赋值给activityLevelName（活动层级名称）
        this.$set(this.activityData,'activityLevelName',levelFound.fieldValue)
      }
    })
    // switch (this.activityData.activityClassificationCode) {
    //   case 'AC_03':
    //   case 'AC_06':
    //     this.activityData.relationActivityName = this.$t('home.ha');
    //     break;
    //   case 'AC_01':
    //     this.activityData.relationActivityName = this.$t('newApp.activityInfo.ta');
    //     break;
    // }

    // switch (this.activityData.activityLevel) {
    //   case 'A':
    //      this.activityData.activityLevelName = 'A类重点活动';
    //     break;
    //   case 'B':
    //     this.activityData.activityLevelName = 'B类小型会议';
    //     break;
    //   case 'C':
    //      this.activityData.activityLevelName = 'C类关系活动';
    //     break;
    //     case 'D':
    //      this.activityData.activityLevelName = 'D类数字营销';
    //     break;
    // }

    // 活动预计板块
    if (this.echoData.mactModuleList && this.echoData.mactModuleList.length > 0) {
      this.activityData.mactModuleList = this.echoData.mactModuleList.map(item => {
        return item.moduleName;
      }).join('，');
    }
    // 产品线
    if (this.echoData.mactProductLineList && this.echoData.mactProductLineList.length > 0) {
      this.activityData.productlineSupplement = this.echoData.mactProductLineList.map(item => {
        if (item.productLineName.indexOf('其他') >= 0) {
          item.productLineName = item.customProductLine;
        }
        return item.productLineName;
      }).join('，');
    }
    if (isNotEmpty(this.echoData.mactCommunicationScenarioList)) {
      this.activityData.communicationScenarioList = this.echoData.mactCommunicationScenarioList.map(item => {
        return item.communicationScenarioName;
      }).join('，');
      let params = ['fb_communication_scenario'];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          const list = res.data.fbCommunicationScenario.filter(item => item.flag);
          const index = list.findIndex(item => item.fieldKey === this.echoData.mactCommunicationScenarioList[0].communicationScenarioCode);
          if (index !== -1) {
            this.comscValue = this.$t('newApp.activityInfo.strpr');
          } else {
            this.comscValue = this.$t('newApp.activityInfo.comsc');
          }
        }
      });
    }
    if (isNotEmpty(this.echoData.mactAgendaList)) {
      this.activityData.agendaList = this.echoData.mactAgendaList.map(item => {
        return item.agendaName;
      }).join('，');
    }
  }
};
</script>

<style scoped>

</style>
